import tick_pro from "../../../assets/images/tick_pro.svg";

import bo_pc from "../../../assets/images/bo_pc.webp";
import bo_mo from "../../../assets/images/bo_mo.webp";
import rise_mo from "../../../assets/images/rise_mo.webp";
import rise_pc from "../../../assets/images/rise_pc.webp";
import bigm_mo from "../../../assets/images/bigm_mo.webp";
import bigm_pc from "../../../assets/images/bigm_pc.webp";
import ModalTH from "../../Modal/ModalTH";

export default function ProductssMainof() {
  return (
    <div className="w-full">
      <div className="container mx-auto p-3 flex flex-col gap-5">
        <div className="w-full flex flex-col gap-2 lg:flex-row lg:items-center lg:justify-center lg:gap-3">
          <p className="text-[28px] text-[#033F6A] font-semibold">
            Sản phẩm chính của
          </p>
          <div className="border border-[#27C6FF] w-[7.125rem] h-10 rounded-[40px] bg-[#27C6FF] flex items-center justify-center">
            <p className="text-[16px] font-semibold text-white">BlueSkyIT</p>
          </div>
        </div>

        <div className="w-full grid grid-cols-1 lg:grid-cols-3 gap-3">
          <div className="border border-solid border-[#E2E2E2] w-full flex flex-col gap-5 bg-white rounded-[24px] px-[24px] py-[24px]">
            <div>
              <p className="text-[20px] text-[#1375B7] font-semibold">
                Dầu bơ ép lạnh thượng hạng Keyavo
              </p>
            </div>
            <div>
              <p className="text-[16px] text-[#333333] font-normal lg:w-full">
                Keyavo – dầu bơ nguyên chất, ép lạnh tự nhiên, giữ nguyên các
                dưỡng chất quý giá từ quả bơ. Sản phẩm giàu Vitamin E, Omega 3,
                6, 9, giúp hỗ trợ sức khỏe tim mạch và làm đẹp da.”
              </p>
            </div>
            <div className="flex flex-col gap-3">
              <div className="flex items-center gap-3">
                <div className="w-[30px] h-[30px] rounded-full flex items-center justify-center bg-[#1C9BDB]">
                  <img src={tick_pro} alt="" />
                </div>
                <div>
                  <p className="text-[16px] text-[#333333] font-normal lg:w-full">
                    100% nguyên chất từ quả bơ.
                  </p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-[30px] h-[30px] rounded-full flex items-center justify-center bg-[#1C9BDB]">
                  <img src={tick_pro} alt="" />
                </div>
                <div>
                  <p className="text-[16px] text-[#333333] font-normal lg:w-full">
                    Quy trình ép lạnh giữ trọn dưỡng chất.
                  </p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-[30px] h-[30px] rounded-full flex items-center justify-center bg-[#1C9BDB]">
                  <img src={tick_pro} alt="" />
                </div>
                <div>
                  <p className="text-[16px] text-[#333333] font-normal lg:w-full">
                    Hỗ trợ sức khỏe toàn diện.
                  </p>
                </div>
              </div>
            </div>
            <div className="w-full h-[54px] rounded-[30px] lg:w-full hover:bg-[#27C6FF] hover:text-white bg-[#1C9BDB] flex items-center justify-center gap-2 text-white">
              <ModalTH />
            </div>
            <div className="flex items-center justify-center">
              <img
                src={bo_mo}
                alt=""
                className="block md:hidden lg:hidden max-w-full h-auto object-contain"
              />
              <img
                src={bo_pc}
                alt=""
                className="hidden md:block lg:block object-contain lg:relative lg:bottom-[-120px]"
              />
            </div>
          </div>
          <div className="border border-solid border-[#E2E2E2] w-full flex flex-col gap-5 bg-white rounded-[24px] px-[24px] py-[24px]">
            <div>
              <p className="text-[20px] text-[#1375B7] font-semibold">
                Hệ thống quản trị giáo dục Blue Rise
              </p>
            </div>
            <div>
              <p className="text-[16px] text-[#333333] font-normal lg:w-full">
                Blue Rise là giải pháp DUY NHẤT trên thị trường quản trị toàn
                diện cho các trung tâm giáo dục: giúp quản lý tuyển sinh, lịch
                học, học viên và đội ngũ giảng viên một cách hiệu quả. Đặc biệt,
                Blue Rise tạo ra cộng đồng hỏi đáp 24/7, nâng cao trải nghiệm
                học tập và giúp tăng tỷ lệ học sinh tái phí.
              </p>
            </div>
            <div className="flex flex-col gap-3 w-full">
              <div className="flex items-center gap-3 w-full">
                <div className="w-[30px] h-[30px] rounded-full flex items-center justify-center bg-[#1C9BDB]">
                  <img src={tick_pro} alt="" />
                </div>
                <div>
                  <p className="text-[16px] text-[#333333] font-normal w-[262px]">
                    Hỗ trợ tuyển sinh nhờ cộng đồng hỏi đáp 24/7
                  </p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-[30px] h-[30px]  rounded-full flex items-center justify-center bg-[#1C9BDB]">
                  <img src={tick_pro} alt="" />
                </div>
                <div>
                  <p className="text-[16px] text-[#333333] font-normal w-[262px] ">
                    Nâng cao trải nghiệm học tập và tăng tỷ lệ học sinh tái phí.
                  </p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-[30px] h-[30px]  rounded-full flex items-center justify-center bg-[#1C9BDB]">
                  <img src={tick_pro} alt="" />
                </div>
                <div>
                  <p className="text-[16px] text-[#333333] font-normal w-[262px] ">
                    Quản lý toàn diện các hoạt động của trung tâm giáo dục.
                  </p>
                </div>
              </div>
            </div>
            <div className="w-full h-[54px] rounded-[30px] lg:w-full hover:bg-[#27C6FF] hover:text-white bg-[#1C9BDB] flex items-center justify-center gap-2 text-white">
              <ModalTH />
            </div>
            <div className="flex items-center justify-center">
              <img
                src={rise_mo}
                alt=""
                className="block md:hidden lg:hidden max-w-full h-auto object-contain"
              />
              <img
                src={rise_pc}
                alt=""
                className="hidden md:block lg:block object-contain"
              />
            </div>
          </div>
          <div className="border border-solid border-[#E2E2E2] w-full flex flex-col gap-5 bg-white rounded-[24px] px-[24px] py-[24px]">
            <div>
              <p className="text-[20px] text-[#1375B7] font-semibold">
                Học viện giáo dục Bigmax Academy
              </p>
            </div>
            <div>
              <p className="text-[16px] text-[#333333] font-normal ">
                Bigmax Academy cung cấp các khóa học đào tạo chuyên sâu về kỹ
                năng mềm, công nghệ và quản trị, dành cho người trẻ và các
                chuyên gia. Với đội ngũ giảng viên chất lượng và giáo trình
                chuẩn quốc tế, Bigmax giúp học viên phát triển toàn diện
              </p>
            </div>
            <div className="flex flex-col gap-3 w-full">
              <div className="flex items-center gap-3">
                <div className="w-[30px] h-[30px] rounded-full flex items-center justify-center bg-[#1C9BDB]">
                  <img src={tick_pro} alt="" />
                </div>
                <div>
                  <p className="text-[16px] text-[#333333] font-normal w-[262px] ">
                    Khóa học đa dạng và phù hợp với mọi đối tượng.
                  </p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-[30px] h-[30px]  rounded-full flex items-center justify-center bg-[#1C9BDB] ">
                  <img src={tick_pro} alt="" />
                </div>
                <div>
                  <p className="text-[16px] text-[#333333] font-normal w-[262px] ">
                    Giảng viên chuyên nghiệp với kinh nghiệm thực tiễn.
                  </p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-[30px] h-[30px]  rounded-full flex items-center justify-center bg-[#1C9BDB]">
                  <img src={tick_pro} alt="" />
                </div>
                <div>
                  <p className="text-[16px] text-[#333333] font-normal w-[262px] ">
                    Lộ trình học rõ ràng, cá nhân hóa cho từng học viên.
                  </p>
                </div>
              </div>
            </div>
            <div className="w-full h-[54px] rounded-[30px] hover:bg-[#27C6FF] hover:text-white lg:w-full bg-[#1C9BDB] flex items-center justify-center gap-2 text-white">
              <ModalTH />
            </div>
            <div className="flex items-center justify-center">
              <img
                src={bigm_mo}
                alt=""
                className="block md:hidden lg:hidden max-w-full h-auto object-contain"
              />
              <img
                src={bigm_pc}
                alt=""
                className="hidden md:block lg:block object-contain"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
